import { render, staticRenderFns } from "./SpecialOfferProduct.vue?vue&type=template&id=4907f4f8&scoped=true&"
import script from "./SpecialOfferProduct.vue?vue&type=script&lang=js&"
export * from "./SpecialOfferProduct.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOfferProduct.vue?vue&type=style&index=0&id=4907f4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4907f4f8",
  null
  
)

export default component.exports